module.exports = __webpack_public_path__ + "img/calendar--event 1.0540baa9.svg";